import { useState } from "react";
import { Link } from "react-router-dom";
import { http, formatErr } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import { toast } from "sonner";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

/**
 * Recupero password — richiesta link temporaneo monouso via email.
 * Risposta sempre generica (nessuna enumerazione account). Non invia mai la
 * password attuale. Flusso condiviso da tutti i ruoli.
 */
export default function PlatformForgotPassword() {
  const { brand } = useBrand();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/auth/request-password-reset", { email });
      setMsg(data?.message || "Se l'indirizzo è associato a un account, riceverai un'email.");
      setSent(true);
    } catch (err) {
      toast.error(formatErr(err));
    }
    setBusy(false);
  };

  return (
    <div data-testid="platform-forgot-password-page" className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "linear-gradient(135deg, var(--brand-dark) 0%, #2d1526 100%)", color: "white" }}>
      <div className="w-full max-w-md p-8 rounded-2xl border border-white/10" style={{ background: "rgba(255,255,255,0.04)" }}>
        <h1 className="font-serif text-2xl mb-1">{brand.display_name}</h1>
        <p className="text-xs text-white/60 mb-6">Recupero password</p>

        {sent ? (
          <div data-testid="forgot-sent-message" className="text-center">
            <CheckCircle2 className="w-10 h-10 mx-auto mb-3" style={{ color: "var(--brand-accent)" }} />
            <p className="text-sm text-white/80">{msg}</p>
            <Link to="/platform/login" className="inline-flex items-center gap-1 mt-6 text-xs underline text-white/70 hover:text-white"
              data-testid="forgot-back-login">
              <ArrowLeft className="w-3 h-3" /> Torna al login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <label className="block mb-5">
              <span className="text-xs uppercase tracking-widest text-white/60 mb-2 block">Email dell'account</span>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                data-testid="forgot-email" autoComplete="username"
                className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/20 focus:outline-none" />
            </label>
            <button type="submit" disabled={busy} data-testid="forgot-submit"
              className="w-full py-3 rounded-lg disabled:opacity-50 uppercase tracking-widest text-sm flex items-center justify-center gap-2"
              style={{ background: "var(--brand-primary)", color: "white" }}>
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
              Invia link di reset
            </button>
            <p className="text-[11px] text-white/50 mt-4 leading-relaxed">
              Non ricordi l'email di accesso? Per motivi di sicurezza non mostriamo gli account registrati:
              contatta l'amministratore della piattaforma per assistenza.
            </p>
            <Link to="/platform/login" className="inline-flex items-center gap-1 mt-5 text-xs underline text-white/70 hover:text-white"
              data-testid="forgot-back-login">
              <ArrowLeft className="w-3 h-3" /> Torna al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
